const cdnFileNamePattern = /.*\/(.*?\.[\w\d]{2,4})/;

export default cdnFileNamePattern;